import { render, staticRenderFns } from "./BaseDescription.vue?vue&type=template&id=19b89038&scoped=true"
import script from "./BaseDescription.vue?vue&type=script&lang=js"
export * from "./BaseDescription.vue?vue&type=script&lang=js"
import style0 from "./BaseDescription.vue?vue&type=style&index=0&id=19b89038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b89038",
  null
  
)

export default component.exports